import { useMemo } from 'react'
import { Chart as ChartJS, CategoryScale, LinearScale, Title, Tooltip, Legend, BarElement, LogarithmicScale, ChartData } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LogarithmicScale)

export type WeeklyBarChartProps = {
  chartData?: Pick<ChartData<'bar', number[]>, 'datasets' | 'labels'>
  title: string
  label: string
}

// TODO: Create a generic bar chart
function WeeklyBarChart(props: WeeklyBarChartProps) {
  const { chartData, title, label } = props

  const { t } = useTranslation()

  const options = {
    responsive: true,
  }

  const extendedChartData = useMemo(() => {
    return {
      labels: chartData?.labels ?? [],
      datasets:
        chartData?.datasets.map((dataset) => ({
          label: title,
          // labels: sortedData.map((week) => `${week.week} - ${week.year}`),
          data: dataset.data,
          tension: 0.5,
          backgroundColor: 'indigo',
        })) ?? [],
    }
  }, [chartData, label, t])

  return (
    <>
      <Typography variant="h2">{title}</Typography>
      <Bar data={extendedChartData} options={options} />
    </>
  )
}

export default WeeklyBarChart
